import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconLookup } from '@fortawesome/fontawesome-svg-core';

type Props = {
  icon: IconLookup;
};

const PaymentMethodIcon: FC<Props> = ({ icon }) => {
  return <FontAwesomeIcon className="text-slate-500 mr-2" icon={icon} size="2x" />;
};

export default PaymentMethodIcon;
